import script from "./NavigatorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigatorComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavigatorComponent.vue?vue&type=style&index=0&id=ba2c7188&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba2c7188"]])

export default __exports__